import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const problems = ['Apuntes desordenados de mil fuentes distintas', 'Resúmenes que no diferencian lo importante de lo accesorio', 'Vías metabólicas que memorizás y olvidás a la semana', 'Cero organización entre parciales, prácticas y finales', 'Horas perdidas armando material que ya debería existir', 'Empezás a estudiar, te frustrás, lo dejás para último momento'];
export function Problem() {
  return <section className="bg-brand-light py-16 px-4 sm:px-6 lg:px-8" data-id="element-205">
      <div className="max-w-2xl mx-auto" data-id="element-206">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-207">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-brand-dark mb-4" data-id="element-208">
            ¿Cuántas veces más vas a empezar de cero?
          </h2>
          <p className="text-center text-brand-dark/80 mb-8 text-lg font-medium" data-id="element-209">
            Sin un sistema claro, siempre terminás igual.
          </p>

          <div className="bg-white rounded-2xl p-6 border border-gray-200 mb-8 shadow-sm" data-id="element-210">
            <ul className="space-y-4" data-id="element-211">
              {problems.map((problem, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3 text-brand-dark" data-id="element-212">
                  <div className="mt-0.5 bg-red-100 p-1 rounded-full flex-shrink-0" data-id="element-213">
                    <X className="w-3 h-3 text-red-500" data-id="element-214" />
                  </div>
                  <span className="text-[15px] font-medium" data-id="element-215">{problem}</span>
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-brand-teal rounded-2xl p-6 text-center shadow-lg" data-id="element-216">
            <p className="text-white font-medium text-lg" data-id="element-217">
              No es falta de capacidad. Es falta de un sistema.
              <br data-id="element-218" />
              <span className="font-bold mt-2 block" data-id="element-219">
                Con BioKit Universitario, el próximo parcial puede ser
                diferente. 🧪
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}